var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAgent = function SvgAgent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    fill: "currentColor",
    style: {
      color: "#2d4e6d"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 .335a.665.665 0 1 0 0 1.33h2.002v1.337H3.667A1.998 1.998 0 0 0 1.668 5v2.002H1a.665.665 0 1 0 0 1.33h.668v2.001c0 1.104.895 1.999 1.999 1.999h8a1.998 1.998 0 0 0 1.998-1.999V8.332h.668a.665.665 0 1 0 0-1.33h-.668V5a1.998 1.998 0 0 0-1.998-1.998H8.332V1a.665.665 0 0 0-.665-.665H5ZM3.667 4.332h8c.369 0 .668.299.668.668v5.333c0 .37-.3.669-.668.669h-8c-.37 0-.669-.3-.669-.669V5c0-.37.3-.668.669-.668ZM6.332 7a.665.665 0 1 0-1.33 0v1.333a.665.665 0 1 0 1.33 0V7Zm4 0a.665.665 0 0 0-1.33 0v1.333a.665.665 0 1 0 1.33 0V7Z",
    clipRule: "evenodd"
  })));
};
export default SvgAgent;